import { ActionContext }                         from 'vuex';
import i18n                                      from '@/i18n';
import { RootState }                             from '@/store/store.types';
import { State, SubmitForm }                     from '@/views/events/submodules/events-detail.types';
import { getOneEvent, submitEvent, updateEvent } from '@/views/events/submodules/service/events-detail.service';
import { useEventDetailGenerateSubmit }          from '@/views/events/submodules/hooks/use-event-detail-generate-submit';
import { Notification }                          from '@/components/notification/notification';
import { useGlobals }                            from '@/hooks/use-globals';
import { getViewStorePath }                      from '@/store/store.helpers';
import { handleClientBasicError }                from '@/helpers/helpers';

export default {
  async submitEvent(context: ActionContext<State, RootState>, eventUuid?: string): Promise<void> {
    try {
      context.commit('setLoading', true);
      if (eventUuid) {
        await updateEvent(useEventDetailGenerateSubmit(context.state), eventUuid);
        await context.dispatch('updatePriceOptimizer');

        Notification.success(
          i18n.t(`${context.rootState.i18n.GLOBAL_PATH}.success.success`),
          i18n.t(`${context.rootState.i18n.GLOBAL_PATH}.success.eventUpdated`),
        );
      } else {
        await submitEvent(useEventDetailGenerateSubmit(context.state));
        await context.dispatch('updatePriceOptimizer');

        Notification.success(
          i18n.t(`${context.rootState.i18n.GLOBAL_PATH}.success.success`),
          i18n.t(`${context.rootState.i18n.GLOBAL_PATH}.success.eventCreated`),
        );
      }
    } catch (e) {
      handleClientBasicError(e);
    } finally {
      context.commit('setLoading', false);
    }
  },
  async updatePriceOptimizer(context: ActionContext<State, RootState>): Promise<void> {
    const { store } = useGlobals();
    const rule = !!context.rootState.views.vPriceOptimizer;
    if (rule) {
      await store.dispatch(`${getViewStorePath('vPriceOptimizer')}/getTableResults`);
    }
  },
  async getOneEvent(context: ActionContext<State, RootState>, eventUuid: string): Promise<void> {
    try {
      const { data }: { data: SubmitForm } = await getOneEvent(eventUuid);
      context.commit('setOneEvent', { data, eventUuid });
    } catch (e) {
      Notification.error(
        i18n.t(`${context.rootState.i18n.GLOBAL_PATH}.errors.error`),
        i18n.t(`${context.rootState.i18n.GLOBAL_PATH}.errors.somethingWentWrong`),
      );

      throw new Error(e);
    }
  },
};
